export const alertsRoutes = (root: string) => ({
  root,
  view: () => {
    return `${root}/view/:alertId`;
  },
});
